import api from './apiConfig';

// POST /frontsite-api/v1/learner/error-report/submit
export const submitErrorReport = async (payload) => {
  try {
    const response = await api.post('/frontsite-api/v1/learner/error-report/submit', payload, {
      // Prevent self-report recursion when this endpoint fails
      skipErrorTracking: true,
      meta: {
        page: 'Global',
        action: 'submit-error-report',
      },
    });

    return {
      success: response.data?.status === 'ok',
      data: response.data?.data,
      message: response.data?.message,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message || 'Failed to submit error report',
    };
  }
};
